import { ELinkColorVariant, ELinkVariant, ETextStyleVariant, Link } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import { OptimizelyFlags, useExperimentIsEnabled } from '@/services/experiments';

interface IProps {
  onReset: () => void;
  isBringItToMeFilter?: boolean;
}

const FilterResetButton: React.FC<IProps & React.HTMLAttributes<HTMLButtonElement>> = ({
  onReset,
  isBringItToMeFilter = false,
}) => {
  const intl = useIntl();
  const isRentalsVDeliverySearchModeEnabled = useExperimentIsEnabled(
    OptimizelyFlags.RENTAL_V_DELIVERY_SEARCH_MODE,
  );

  const shouldShowClear = isBringItToMeFilter && isRentalsVDeliverySearchModeEnabled;

  const defaultTitle = shouldShowClear
    ? intl.formatMessage({
        defaultMessage: 'Clear',
        id: '4VO4qf',
        description: 'Bring it to me clear button',
      })
    : intl.formatMessage({
        defaultMessage: 'Reset',
        id: '/Uc10X',
        description: 'menu filter reset button',
      });

  return (
    <Link
      variant={ELinkVariant.Underline}
      onClick={onReset}
      target="_blank"
      colorVariant={ELinkColorVariant.Primary}
      textVariant={ETextStyleVariant.MediumBold}
      label={defaultTitle}
    />
  );
};

export default FilterResetButton;
